import { BlogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type CreateBlogsFilesInput = {
  formData?: {
    File: Blob;
  };
};

export const useCreateBlogsFilesMutation = (
  options?: ApiMutationOptions<typeof BlogService.postBlogsFiles, CreateBlogsFilesInput>
) =>
  useMutationWithNotifications(({ formData }: CreateBlogsFilesInput) => BlogService.postBlogsFiles(formData), options);
